import React, { lazy, Suspense } from 'react';
import { Icon, Title } from '@landing/ui';
import { useIsSsr } from 'utils/hooks';

import * as styles from './IntroDefault.module.scss';

const Animation = lazy(() => import('components/UI/Animation'));

export default function IntroDefault({
  title,
  subtitle,
  date,
  meetupStartTime,
  timeZone,
  location,
  meetupType,
}) {
  const isSsr = useIsSsr();

  return (
    <div className={styles.layout}>
      <Title className={styles.title} tag="h1" color="white">
        {title}
      </Title>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      <div className={styles.details}>
        <div className={styles.detailsItem}>
          <Icon name="calendar" className={styles.detailIcon} />
          <span>{date}</span>
        </div>
        {meetupStartTime && (
          <div className={styles.detailsItem}>
            <Icon name="clock" className={styles.detailIcon} />
            <span>{`${meetupStartTime} ${timeZone}`}</span>
          </div>
        )}
        {location && (
          <div className={styles.detailsItem}>
            <Icon name="marker" className={styles.detailIcon} />
            <span>{location}</span>
          </div>
        )}
        {meetupType && (
          <div className={styles.detailsItem}>
            <Icon name="planet" className={styles.detailIcon} />
            <span>{meetupType}</span>
          </div>
        )}
      </div>
      {!isSsr && (
        <Suspense fallback={null}>
          <Animation preserveAspectRatio className={styles.animation} name="intro" />
        </Suspense>
      )}
    </div>
  );
}
